import { useState, useEffect } from "react";
import {getData} from '../middleware/apiMiddleware';
import { NavLink } from 'react-router-dom';
import s from './Navbar.module.css';
import mainLogo from'../asset/logo.png';
import { ReactComponent as BarsSolid} from '../asset/bars-solid.svg';
import { ReactComponent as XmarkSolid} from '../asset/xmark-solid.svg';
import { clearJWTToken } from '../middleware/dataStorage';
import { useNavigate } from "react-router-dom";

const itemMenu = [
	{
    title: 'PDF',
    url: '/pdfitems',
    submenu: [
      { title: 'create PDF', url: '/pdfitemcreation', },
    ],
  },
	{
    title: 'Tutor',
    url: '/tutors',
    submenu: [
      { title: 'Syllabus', url: '/syllabus', },
      { title: 'User writing', url: '/userwriting', },
      { title: 'Online Class', url: '/onlineClass', },
      { title: 'Fail writing', url: '/writingAnalysis', },
      { title: 'Listening', url: '/listening-analysis', },
    ],
  },
	{
    title: 'Users',
    url: '/students',
    submenu: [
      { title: 'Users', url: '/students', },
    ],
  },
	{
    title: 'Schools',
    url: '/schools',
    submenu: [
      { title: 'Schools', url: '/schools', },
    ],
  },
  {
    title: 'Word',
    url: '/words',
    submenu: [
      { title: 'Summary', url: '/word-summary', },
    ],
  },
  {
    title: 'Items',
    url: '/item-summary',
    submenu: [
      { title: 'Summary', url: '/item-analysis', },
      { title: 'Config', url: '/item-config', },
      { title: 'System-Config', url: '/systemConfig', },
      { title: 'Ordering', url: '/item-ordering', },
      { title: 'Book', url: '/books', },
      { title: 'Card', url: '/cards', },
    ],
  }
];


const SubMenuObj = ({title, url}) => {
	return (<li className={s.subMenuTitle}>
		<NavLink to={url}><span>{title}</span></NavLink>
	</li>)
}

const MenuObj = (prop) => {
	let title = prop.data.title;
	let url = prop.data.url;
	let submenu = prop.data.submenu;

  return (
			<li className={s.mainMenu} >
				<div className={s.mainMenuTitle}>
					<NavLink to={url}><span>{title}</span></NavLink>
				</div>
				
				<ul className={s.dropdownMenu}>
					{
						submenu.map((s, indexS) => (<SubMenuObj key={"submenu-"+indexS} title={s.title} url={s.url} />))
					}
				</ul>
			</li>		
  );
}

export default function NavBar() {
	const navigate = useNavigate();
	
	const [iconOn, setIconOn] = useState(false);
	
	const [roleId, setRoleId] = useState(4);
	
	const logout = () => {
		clearJWTToken();
		navigate('/login');
	}
	
	useEffect(() => {
		getData('user/validateToken', navigate)
		.then(res => {
				setRoleId(res.roleId);
				console.log(res.roleId);
			}
		);
	}, []);
	return (
		<>
			<nav className={s.nav}>
				<div>
					<img style={{width:"50px", height:"50px"}} src={mainLogo} alt="icon"/>
				</div>
				<div >
					<ul className={s.navbar + ' ' + (iconOn ? s.active : "")} >
						{
							itemMenu.map((d, indexD) => (<MenuObj key={"menu-"+indexD} data={d}/>))
						}
						
						<li className={s.logout_btn_sm} onClick={logout}>
							<a>logout</a>
						</li>
					</ul>
				</div>
				<div className={s.logout_btn} onClick={logout}>logout</div>
				<div className={s.mobile}  onClick={() => setIconOn(p => !p)}>
					{
						iconOn ? 
						<XmarkSolid fill='white' stroke='white'/> : <BarsSolid fill='white' stroke='white'/>
					}
				</div>
			</nav>
		</>
	);
}